const SITE = "https://interorman.com.tr";

export const setSeo = ({ title, description, path }) => {
  if (title) document.title = title;
  if (description) {
    let m = document.querySelector('meta[name="description"]');
    if (!m) {
      m = document.createElement("meta");
      m.setAttribute("name", "description");
      document.head.appendChild(m);
    }
    m.setAttribute("content", description);
  }
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", SITE + (path ?? window.location.pathname));
};

// Kategori sayfası için ürün listesi yapılandırılmış verisi (Google görsel sonuçları)
export const setProductListJsonLd = ({ name, path, products }) => {
  const absImg = (img) => (img.startsWith("http") ? img : SITE + img);
  const data = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name,
    url: SITE + path,
    mainEntity: {
      "@type": "ItemList",
      itemListElement: products
        .filter((p) => p.image)
        .slice(0, 12)
        .map((p, i) => ({
          "@type": "ListItem",
          position: i + 1,
          item: { "@type": "Product", name: p.name, image: absImg(p.image) },
        })),
    },
  };
  let s = document.getElementById("jsonld-products");
  if (!s) {
    s = document.createElement("script");
    s.type = "application/ld+json";
    s.id = "jsonld-products";
    document.head.appendChild(s);
  }
  s.textContent = JSON.stringify(data);
  // og:image — ilk ürün görseli
  const first = products.find((p) => p.image);
  if (first) {
    let og = document.querySelector('meta[property="og:image"]');
    if (!og) {
      og = document.createElement("meta");
      og.setAttribute("property", "og:image");
      document.head.appendChild(og);
    }
    og.setAttribute("content", absImg(first.image));
  }
};

export const clearProductListJsonLd = () => {
  const s = document.getElementById("jsonld-products");
  if (s) s.remove();
};
